.wrapper {
  width: 100%;
  margin: 0 1rem;
}

aside {
  display: none;
}

.selectionLists {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

@media (min-width: 30em) {

}

@media (min-width: 48em) {

  .wrapper {
    max-width: 48rem;
  }

  aside {
    display: flex;
  }

}

@media (min-width: 64em) {
  .wrapper {
    max-width: 64rem;
  }

  .selectionLists {
    flex-direction: row;
  }
}

@media (min-width: 80em) {

  .wrapper {
    max-width: 80rem;
  }
}
